/**
 * @Author: Zewei
 * @Date:   2018-01-29T10:19:18+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-01-31T18:10:06+08:00
 */

import _util from '../../utils/';

const DepartmentStructure = {
    getDepartmentsList (params, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/GetAll',
            params: params,
            success: resolve,
            error: reject
        })
    },
    getDepartmentsDetail (params, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Details',
            params: params,
            success: resolve,
            error: reject
        })
    },


    reviewAttendanceRecord (data, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceRecords/Audit',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },



    getDepartmentsInit (resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Create',
            success: resolve,
            error: reject
        })
    },
    createNewDepartment (data, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Create',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    updateNewDepartment (data, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Update',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    multiCreateDepartments (data, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/MultiCreate',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    mergeDepartments (data, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Merge',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    sequenceDepartments (data, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Move',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    deleteDepartment (data, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    createNewDepartmentEx(params, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Create',
            params: params,
            success: resolve,
            error: reject
        });
    },
    addDepartmentEx(posts, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Create',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });        
    },
    updateDepartmentEx(params, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Update',
            params: params,
            success: resolve,
            error: reject
        });         
    },
    updateDepartmentActionEx(puts, resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/Update',
            method: "put",
            data: puts,
            success: resolve,
            error: reject
        });          
    }
}

const DepartmentStructureService = DepartmentStructure;

export { DepartmentStructureService };

export default DepartmentStructure;



// WEBPACK FOOTER //
// ./src/services/DepartmentStructure/department-structure-service.js